import { graphql } from '@graphql/gql';

export const GET_POST_REG_REDIRECT_URL = graphql(`
  query GET_POST_REG_REDIRECT_URL($eventId: String!, $attendeeEmail: String!, $attendeeId: String) {
    postRegRedirectUrl(eventId: $eventId, attendeeEmail: $attendeeEmail, attendeeId: $attendeeId) {
      redirect
      postRegRedirectUrl {
        id
        verificationId
      }
    }
  }
`);
